import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { SurveyTheme } from "../types/surveyTheme";
import { HexCode, HexCodeDTO } from "../types/hexCode";

export interface ThemeWithHexCodesDTO {
  theme: SurveyTheme.SurveyThemeDTO;
  primaryHexCode: HexCodeDTO;
}

export class ThemeWithHexCodes {
  readonly isThemeWithHexCodesThemeWithHexCodes: boolean = true;

  readonly theme: SurveyTheme.SurveyTheme;
  readonly primaryHexCode: HexCode;


  constructor(
  theme: SurveyTheme.SurveyTheme, 
  primaryHexCode: HexCode
  ) {
    this.theme = theme;
    this.primaryHexCode = primaryHexCode;
  }

  static fromDTO(dto: ThemeWithHexCodesDTO): ThemeWithHexCodes {
    const theme = SurveyTheme.fromDTO(getObject(dto, "theme", InvalidThemeWithHexCodesThemeError));
    const primaryHexCode = HexCode.fromDTO(getObject(dto, "primaryHexCode", InvalidThemeWithHexCodesPrimaryHexCodeError));
    return new ThemeWithHexCodes(
      theme,
      primaryHexCode
    );
  }

  toDTO(): ThemeWithHexCodesDTO {
    const dto: ThemeWithHexCodesDTO = {
        theme: SurveyTheme.toDTO(this.theme),
        primaryHexCode: this.primaryHexCode.toDTO()
    };
    return dto;
  }
  }

ThemeWithHexCodes.prototype.toString = function toString(): string {
  return `ThemeWithHexCodes(theme='${this.theme}',primaryHexCode='${this.primaryHexCode}')`;
};

export class InvalidThemeWithHexCodesError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidThemeWithHexCodesError";
  }
}
export class InvalidThemeWithHexCodesThemeError extends InvalidThemeWithHexCodesError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidThemeWithHexCodesThemeError";
  }
}

export class InvalidThemeWithHexCodesPrimaryHexCodeError extends InvalidThemeWithHexCodesError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidThemeWithHexCodesPrimaryHexCodeError";
  }
}
